import React, { useState, } from "react";
import "./ContactUs.css";
import { ReactComponent as ContactUs } from "images/goopter-contact-us.svg";
import { ReactComponent as LeftBg } from "images/background/hero-section-red-triangle.svg";
import { ReactComponent as RedShadow } from "images/background/software-solution-graphic-red.svg";
import { ReactComponent as RightBg } from "images/background/right-box-graphic.svg";
import { ReactComponent as LeftBox } from "images/background/right-box-graphic.svg";
import WaitingFor from "components/Banner/WaitingFor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faFacebook,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  faPhoneAlt,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { getData } from "app/data";
import { rootUrl } from "config/setting";


export default function Index() {
  const [status, setStatus] = useState("Submit");

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus("Sending...");
    const { name, email, subject, message } = e.target.elements;
    let details = {
      "your-name": name.value,
      "your-email": email.value,
      "your-subject": subject.value,
      "your-message": message.value,
    };

    const form = new FormData();
    for (const field in details) {
      form.append(field, details[field]);
    }
    axios
      .post(
        `${rootUrl}/wp-json/contact-form-7/v1/contact-forms/429/feedback`,
        form,
        { headers: { "content-type": "multipart/form-data" } }
      )
      .then(function (response) {
        console.log(response);
        alert(response.data.message);
        setStatus("Submit");
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div className="contact-us" >
      <div className="page-header">
        <LeftBg className="left-bg" />
        <RightBg className="right-bg" />
        <RedShadow className="red-shadow-bg" />
        <LeftBox className="left-box-mobile" />
        <div className="row">
          <div className="col-lg-5 col-sm-12 text-col">
            <div className="page-header-title">
              <p className="sub-title weaker">
                {getData("contactData").header.subtitle}
              </p>
              <h2>{getData("contactData").header.title}</h2>
            </div>
            <div className="text">{getData("contactData").header.text}</div>
          </div>
          <div className="col-lg-7 col-sm-12 header-image">
            <ContactUs />
          </div>
        </div>
      </div>
      <div className="background" >
        <RightBg className="background-left-bg" />
        <div className="contents" >
          <div className="row head-office">
            <div className="col-lg-6 col-sm-12">
              <div className="text-wrapper">
                <div className="title">
                  <h2>{getData("contactData").head_office.title}</h2>
                </div>
                <ul>
                  {getData("contactData").head_office.offices.map(item => (
                    <>
                      <li className="d-flex">
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          className="contact-icon"
                        />
                        <p>{item.email}</p>
                      </li>
                      <li className="d-flex">
                        <FontAwesomeIcon
                          icon={faPhoneAlt}
                          className="contact-icon"
                        />

                        <p>{item.phone}</p>
                      </li>
                      <li className="d-flex">
                        <FontAwesomeIcon
                          icon={faMapMarkerAlt}
                          className="contact-icon"
                        />
                        <div className="address-wrapper">
                          {item.address.map(line => (
                            <p>{line}</p>
                          ))}
                        </div>
                      </li>
                    </>
                  ))}
                </ul>
                <div className="google-map" >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2606.3416268242136!2d-122.9909842840879!3d49.2130478836226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54867640624769a5%3A0x46e7025473f47dbf!2s7777%20Royal%20Oak%20Ave%2C%20Burnaby%2C%20BC%20V5J%204K2!5e0!3m2!1sen!2sca!4v1635642945182!5m2!1sen!2sca"
                    width={"100%"}
                    height={220}
                    style={{ border: 0 }}
                    allowfullscreen=""
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div
                className="form-wrapper rqp-container"
                iv
                className="rqp__form-container col"
              >
                <form onSubmit={handleSubmit}>
                  <div className="rqp__form-container__inputs">
                    <h2>{getData("contactData").form.title}</h2>
                    <input
                      type="text"
                      placeholder={getData("contactData").form.name}
                      id="name"
                      name="your-name"
                      required
                    />
                    <input
                      type="text"
                      placeholder={getData("contactData").form.email}
                      id="email"
                      name="your-email"
                      required
                    />
                    <input
                      type="text"
                      placeholder={getData("contactData").form.subject}
                      id="subject"
                      name="your-subject"
                      required
                    />
                    <textarea
                      type="text"
                      placeholder={getData("contactData").form.message}
                      id="message"
                      name="your-message"
                      required
                    />
                    <button className="custom-btn green-button" type="submit">
                      {getData("contactData").form.submit}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="other-offices">
              <div className="title">
                <h2> {getData("contactData").other_offices.title}</h2>
              </div>
              <div className="row">
                {getData("contactData").other_offices.offices.map(
                  (item, index) => (
                    <div className="col-lg-4  col-md-4 col-sm-4 other-office">
                      <div
                        className={`contents ${index % 2 === 0 ? "first" : "second"
                          }`}
                      >
                        <h5>{item.name}</h5>
                        <ul>
                          <li className="d-flex">
                            <FontAwesomeIcon
                              icon={faEnvelope}
                              className="contact-icon"
                            />
                            <p>{item.email}</p>
                          </li>
                          <li className="d-flex">
                            <FontAwesomeIcon
                              icon={faPhoneAlt}
                              className="contact-icon"
                            />

                            <p>{item.phone}</p>
                          </li>
                          <li className="d-flex">
                            <FontAwesomeIcon
                              icon={faMapMarkerAlt}
                              className="contact-icon"
                            />
                            <div className="address-wrapper">
                              {item.address.map(line => (
                                <p>{line}</p>
                              ))}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )
                )}
                <div className="col-lg-4 col-md-4 col-sm-4" >
                  <div className="contents third">
                    <h5>{getData("contactData").follow_us}</h5>
                    <div className="icons">
                      <a href="https://www.linkedin.com/company/goopter">
                        <FontAwesomeIcon
                          icon={faLinkedin}
                          style={{ fontSize: "32px" }}
                        />
                      </a>
                      <a href="https://www.facebook.com/gooptercommerce/">
                        <FontAwesomeIcon
                          icon={faFacebook}
                          style={{ fontSize: "32px" }}
                        />
                      </a>
                      <a href="https://www.instagram.com/goopter_commerce/">
                        <FontAwesomeIcon
                          icon={faInstagram}
                          style={{ fontSize: "32px" }}
                        />
                      </a>
                      <a href="https://twitter.com/gooptercommerce">
                        <FontAwesomeIcon
                          icon={faTwitter}
                          style={{ fontSize: "32px" }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div >
            </div>
          </div>
        </div>
      </div>
      <WaitingFor />
    </div>
  );
}
